import {Component} from '@angular/core';
import {
	EntitySelectComponent,
	BaseModel,
	BaseModelInterface,
} from '@app/abstracts';
import {ErrorService} from '@app/services';
import {UserSearchParams} from '../user-search-params';
import {UserService} from '../user.service';
import {User} from '../user';
import { QuickFormService } from '../../../plugins/quick-form';
@Component({
  selector: 'hpf-user-select',
  templateUrl: '../../../abstracts/entity-select/entity-select.component.html'
})
export class UserSelectComponent extends EntitySelectComponent< User> {
  protected modelName = 'user';
  /**
   * Constructor
   * @param {UserService} userService
   * @param {ErrorService} errorService
   */
  constructor(private userService: UserService,
              protected errorService: ErrorService,
              protected quickFormService: QuickFormService) {
    super(errorService, quickFormService);
  }
  ngOnInit() {
		super.ngOnInit();
    // Refresh model in case of creation by quick form
		this.subscriptions.push(
			this.quickFormService.refresh.subscribe(
				(model: BaseModel<BaseModelInterface, {}>) => {
					if(!(model instanceof User)) return;
          if(this.multiple) {
            if (!this.model) this.model = [];
            (<User[]>this.model).push(<User>model);
          } else {
            this.model = <User>model;
          }
          this.refresh();
				}
			)
		);
	}
  /** @inheritDoc */
  protected async getList(): Promise< User[]> {
      const params = new UserSearchParams({
          _limit: this.resultsLimit,
          _page: this.currentPage
      });
      if (this.filterEnabled && this.filterValue) {
        params.props._text = this.filterValue;
      }
      return (await this.userService.list(params.toObject())).items;
  }
  /** @inheritDoc */
  protected async getOne(id: string): Promise< User> {
      return await this.userService.get(id);
  }
}
